<template>
  <div class="formulario-modelo">
    <LoadingOverlay :visible="loading" message="Cargando evaluación..." />

    <MensajeFlotante
      :visible="flotanteVisible"
      :mensaje="flotanteMensaje"
      :tipo="flotanteTipo"
      @cerrar="onCerrarFlotante"
    />

    <div class="header-flex">
      <div>
        <h1>Evaluación Individual</h1>
        <p class="header-sub" v-if="nombreComponente">
          {{ nombreComponente }}<template v-if="!mismoNombre"> · {{ nombreIndicador }}</template>
        </p>
      </div>
      <button type="button" class="btn salir" @click="$router.back()">Cancelar</button>
    </div>

    <div class="divider"></div>

    <form v-if="!loading" class="eval-form" @submit.prevent="guardarEvaluacion">
      <!-- Calificaciones por fuente -->
      <div class="calificaciones-grid">
        <div class="cal-card" :class="{ 'cal-card--error': calFueraRango('calificacion_documental') }">
          <label>Calificación Documental ({{ pct100(pesos.documental) }}%)</label>
          <input
            v-model.number="form.calificacion_documental"
            type="number" min="0" max="5" step="0.1"
            class="cal-input"
            :class="{ 'input--error': calFueraRango('calificacion_documental'), 'cal-input--bloqueado': !estaEnEdicion('calificacion_documental') }"
            :disabled="!estaEnEdicion('calificacion_documental')"
            placeholder="0 - 5"
            @change="clampCal('calificacion_documental')"
          />
          <p v-if="calFueraRango('calificacion_documental')" class="cal-error-msg">El valor debe estar entre 0 y 5</p>
          <div class="range-bar">
            <div class="range-fill" :style="{ width: pct(form.calificacion_documental) + '%' }"></div>
          </div>
          <button
            v-if="!estaEnEdicion('calificacion_documental')"
            type="button"
            class="btn guardar btn-cal-modificar"
            @click="habilitarEdicion('calificacion_documental')"
          >
            Modificar
          </button>
        </div>

        <div class="cal-card" :class="{ 'cal-card--error': calFueraRango('calificacion_cuantitativa') }">
          <label>Calificación Cuantitativa ({{ pct100(pesos.cuantitativa) }}%)</label>
          <input
            v-model.number="form.calificacion_cuantitativa"
            type="number" min="0" max="5" step="0.1"
            class="cal-input"
            :class="{ 'input--error': calFueraRango('calificacion_cuantitativa'), 'cal-input--bloqueado': !estaEnEdicion('calificacion_cuantitativa') }"
            :disabled="!estaEnEdicion('calificacion_cuantitativa')"
            placeholder="0 - 5"
            @change="clampCal('calificacion_cuantitativa')"
          />
          <p v-if="calFueraRango('calificacion_cuantitativa')" class="cal-error-msg">El valor debe estar entre 0 y 5</p>
          <div class="range-bar">
            <div class="range-fill" :style="{ width: pct(form.calificacion_cuantitativa) + '%' }"></div>
          </div>
          <button
            v-if="!estaEnEdicion('calificacion_cuantitativa')"
            type="button"
            class="btn guardar btn-cal-modificar"
            @click="habilitarEdicion('calificacion_cuantitativa')"
          >
            Modificar
          </button>
        </div>

        <div class="cal-card" :class="{ 'cal-card--error': calFueraRango('calificacion_opinion') }">
          <label>Calificación de Opinión ({{ pct100(pesos.opinion) }}%)</label>
          <input
            v-model.number="form.calificacion_opinion"
            type="number" min="0" max="5" step="0.1"
            class="cal-input"
            :class="{ 'input--error': calFueraRango('calificacion_opinion'), 'cal-input--bloqueado': !estaEnEdicion('calificacion_opinion') }"
            :disabled="!estaEnEdicion('calificacion_opinion')"
            placeholder="0 - 5"
            @change="clampCal('calificacion_opinion')"
          />
          <p v-if="calFueraRango('calificacion_opinion')" class="cal-error-msg">El valor debe estar entre 0 y 5</p>
          <div class="range-bar">
            <div class="range-fill" :style="{ width: pct(form.calificacion_opinion) + '%' }"></div>
          </div>
          <button
            v-if="!estaEnEdicion('calificacion_opinion')"
            type="button"
            class="btn guardar btn-cal-modificar"
            @click="habilitarEdicion('calificacion_opinion')"
          >
            Modificar
          </button>
        </div>
      </div>

      <!-- Respuestas del instrumento de opinión -->
      <div v-if="hayInstrumentoOpinion" class="opinion-panel">
        <h3 class="opinion-titulo">Respuestas del instrumento de opinión</h3>

        <div v-if="!respuestasOpinion.length" class="opinion-vacio">
          Sin respuestas registradas aún.
        </div>

        <template v-else>
          <!-- Selector de persona -->
          <div v-if="todosRespondientesOpinion.length" class="persona-filtro">
            <label class="persona-filtro-label">Filtrar por persona:</label>
            <select v-model="personaFiltradaOpinion" class="persona-filtro-select">
              <option :value="null">— Todos —</option>
              <option
                v-for="r in todosRespondientesOpinion"
                :key="r.google_response_id"
                :value="r.google_response_id"
              >
                {{ r.label }}
              </option>
            </select>
          </div>

          <!-- Grupos de respuestas -->
          <div v-for="rf in respuestasOpinion" :key="rf.id_formulario_google" class="resp-grupo-op">
            <h4 class="resp-grupo-titulo">
              {{ rf.grupo_interes?.nombre ?? `Formulario ${rf.id_formulario_google}` }}
              <span class="op-badge">{{ rf.respondientes?.length ?? 0 }}</span>
            </h4>

            <p v-if="!rf.respondientes?.length" class="opinion-vacio">Aún no hay respuestas en este grupo.</p>

            <div
              v-for="p in (personaFiltradaOpinion
                ? rf.respondientes?.filter(r => r.google_response_id === personaFiltradaOpinion)
                : rf.respondientes)"
              :key="p.google_response_id"
              class="persona-card-op"
            >
              <div class="persona-head-op">
                <strong class="persona-nombre-op">{{ p.nombre || p.email || 'Anónimo' }}</strong>
                <span v-if="p.nombre && p.email" class="persona-email-op">{{ p.email }}</span>
                <span v-if="p.respondido_at" class="persona-fecha-op">{{ p.respondido_at.substring(0, 10) }}</span>
              </div>
              <ul class="persona-resp-op">
                <li
                  v-for="r in respuestasDePersonaOpinion(rf, p.google_response_id)"
                  :key="r.id_respuesta"
                  class="pr-item-op"
                >
                  <span class="pr-enunciado-op">{{ r.enunciado }}</span>
                  <span class="pr-valor-op">{{ r.texto ?? r.valor ?? '—' }}</span>
                </li>
              </ul>
            </div>
          </div>
        </template>
      </div>

      <!-- Calificación final calculada -->
      <div class="resultado-final">
        <span class="resultado-label">Calificación Final (calculada)</span>
        <span class="resultado-valor" :class="nivelClass">{{ calificacionFinal.toFixed(2) }}</span>
      </div>

      <!-- Nivel derivado (solo lectura) -->
      <div class="fila">
        <label>Nivel asignado (derivado de la rúbrica MAAM)</label>
        <input :value="nivelDerivado" class="campo-readonly" readonly disabled />
      </div>

      <!-- Observaciones -->
      <div class="fila">
        <label>Observaciones <span class="opcional">(opcional)</span></label>
        <textarea v-model="form.observaciones" class="campo-texto" rows="3" placeholder="Análisis técnico..."></textarea>
      </div>

      <!-- Justificación -->
      <div class="fila">
        <label>Justificación</label>
        <textarea v-model="form.justificacion" class="campo-texto" rows="3" placeholder="Soporte en evidencias..."></textarea>
      </div>

      <!-- Fecha de evaluación -->
      <div class="fila">
        <label>Fecha de evaluación *</label>
        <input v-model="form.fecha_evaluacion" type="date" class="campo-fecha" :max="hoy" />
      </div>

      <!-- Botones -->
      <div class="botones">
        <button type="submit" class="btn guardar" :disabled="guardando || hayCalFueraRango">
          {{ guardando ? 'Guardando...' : (esEdicion ? 'Actualizar Evaluación' : 'Registrar Evaluación') }}
        </button>
      </div>
    </form>
  </div>
</template>

<script setup lang="ts">
/**
 * Calificación de UN indicador por UN evaluador.
 *
 * La nota final, el grado y el nivel los deriva el backend: lo que se envía son
 * las notas por dimensión. Una dimensión que no aplica se deja vacía, NO en cero
 * — la nota final se repondera sobre las presentes.
 *
 * ── Enrutado ─────────────────────────────────────────────────────
 *   `/version/:id_version/indicador/:id_indicador/evaluar` (EvaluacionIndividual) — permiso `calificacion.calificar`
 *
 * Vista enrutada. Obtiene sus datos a través de stores Pinia: no llama a `http`
 * ni a los servicios directamente.
 */

import { ref, computed, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useGestionEvaluacionesIndicadores } from '@/store/GestionEvaluacionesIndicadores'
import { useGestionIndicadores } from '@/store/GestionIndicadores'
import { useComponentes } from '@/store/GestionComponentes'
import useAutenticar from '@/store/IngresoAutenticar'
import { useGestionIndicadorInstrumentos } from '@/store/GestionIndicadorInstrumentos'
import { useGestionConfiguracionInstrumento } from '@/store/GestionConfiguracionInstrumento'
import LoadingOverlay from '@/components/LoadingOverlay.vue'
import MensajeFlotante from '@/components/MensajeFlotante.vue'
import type { RespuestasFormulario, RespuestaIndividual } from '@/interfaces/ConfiguracionInstrumento'
import {
  calcularCalificacionFinal,
  derivarGradoMaam,
  nivelClassMaam,
  pesosDesdeConfiguracion,
  PESOS_MAAM_DEFECTO,
  GRADOS_MAAM_DEFECTO,
  type PesosConsolidacion,
  type GradoMaam
} from '@/utils/consolidacion'
import {
  getConfiguracionVersionService,
  getGradosMaamService
} from '@/services/ConfiguracionEvaluacionService'

const route = useRoute()
const router = useRouter()
const store = useGestionEvaluacionesIndicadores()
const indicadoresStore = useGestionIndicadores()
const componentesStore = useComponentes()
const authStore = useAutenticar()
const indicadorInstrumentoStore = useGestionIndicadorInstrumentos()
const configOpinionStore = useGestionConfiguracionInstrumento()

// ── Feedback ──────────────────────────────────────────────────────────
const flotanteVisible = ref(false)
const flotanteMensaje = ref('')
const flotanteTipo = ref<'positivo' | 'error'>('positivo')
const exitoGuardado = ref(false)

function mostrarExito(msg: string) {
  flotanteMensaje.value = msg
  flotanteTipo.value = 'positivo'
  exitoGuardado.value = true
  flotanteVisible.value = true
}
function mostrarError(msg: string) {
  flotanteMensaje.value = msg
  flotanteTipo.value = 'error'
  exitoGuardado.value = false
  flotanteVisible.value = true
}
function onCerrarFlotante() {
  flotanteVisible.value = false
  if (exitoGuardado.value) {
    router.back()
  }
}

const idVersion = Number(route.params.id_version)
const idIndicador = Number(route.params.id_indicador)
const idUsuario = computed(() => authStore.usuarioActual?.id ?? null)
const nombreComponente = ref('')
const nombreIndicador = ref('')
const mismoNombre = computed(() =>
  !!nombreComponente.value &&
  !!nombreIndicador.value &&
  nombreComponente.value.trim() === nombreIndicador.value.trim()
)

const loading = ref(false)
const guardando = ref(false)
const esEdicion = ref(false)
const evaluacionId = ref<number | null>(null)
const camposEnEdicion = ref<CampoCal[]>([])
const hoy = new Date().toISOString().split('T')[0]

const form = ref({
  calificacion_documental: null as number | null,
  calificacion_cuantitativa: null as number | null,
  calificacion_opinion: null as number | null,
  observaciones: '',
  justificacion: '',
  fecha_evaluacion: hoy
})

const pesos = ref<PesosConsolidacion>({ ...PESOS_MAAM_DEFECTO })
const gradosMaam = ref<GradoMaam[]>([...GRADOS_MAAM_DEFECTO])

async function cargarConfiguracion() {
  const [cfgResult, gradosResult] = await Promise.all([
    getConfiguracionVersionService(idVersion),
    getGradosMaamService()
  ])
  if (cfgResult.ok && cfgResult.data) {
    pesos.value = pesosDesdeConfiguracion(cfgResult.data)
  } else {
    mostrarError('No se pudo cargar la configuración de pesos; se usan los valores MAAM por defecto.')
  }
  if (gradosResult.ok && gradosResult.data?.length) {
    gradosMaam.value = gradosResult.data
  }
}

// ── Validaciones y cálculos ───────────────────────────────────────────
type CampoCal = 'calificacion_documental' | 'calificacion_cuantitativa' | 'calificacion_opinion'

function calFueraRango(campo: CampoCal): boolean {
  const v = form.value[campo]
  return v != null && (v < 0 || v > 5)
}

const hayCalFueraRango = computed(() =>
  calFueraRango('calificacion_documental') ||
  calFueraRango('calificacion_cuantitativa') ||
  calFueraRango('calificacion_opinion')
)

function clampCal(campo: CampoCal) {
  const v = form.value[campo]
  if (v == null) return
  if (v < 0) form.value[campo] = 0
  else if (v > 5) form.value[campo] = 5
}

function estaEnEdicion(campo: CampoCal): boolean {
  const tieneValor = form.value[campo] != null
  return !esEdicion.value || !tieneValor || camposEnEdicion.value.includes(campo)
}

function habilitarEdicion(campo: CampoCal) {
  if (!camposEnEdicion.value.includes(campo)) {
    camposEnEdicion.value = [...camposEnEdicion.value, campo]
  }
}

function pct(val: number | null): number {
  if (val == null || val < 0) return 0
  return Math.min((val / 5) * 100, 100)
}

function pct100(peso: number): number {
  return Math.round(peso * 100)
}

const calificacionFinal = computed(() =>
  calcularCalificacionFinal(
    form.value.calificacion_documental,
    form.value.calificacion_cuantitativa,
    form.value.calificacion_opinion,
    pesos.value
  )
)

const nivelDerivado = computed(() => {
  const tieneCalificacion =
    form.value.calificacion_documental != null ||
    form.value.calificacion_cuantitativa != null ||
    form.value.calificacion_opinion != null
  if (!tieneCalificacion) return '—'
  return derivarGradoMaam(calificacionFinal.value, gradosMaam.value)?.nombre ?? '—'
})

const nivelClass = computed(() => nivelClassMaam(calificacionFinal.value))

// ── Carga de datos ────────────────────────────────────────────────────
async function cargarEvaluacionExistente() {
  loading.value = true
  try {
    const params: { id_version: number; id_indicador: number; id_usuario?: number } = {
      id_version: idVersion,
      id_indicador: idIndicador,
    }
    if (idUsuario.value) params.id_usuario = idUsuario.value

    await store.cargar(params)
    const existente = store.evaluaciones[0]
    if (existente) {
      esEdicion.value = true
      evaluacionId.value = existente.id ?? null
      form.value.calificacion_documental = existente.calificacion_documental ?? null
      form.value.calificacion_cuantitativa = existente.calificacion_cuantitativa ?? null
      form.value.calificacion_opinion = existente.calificacion_opinion ?? null
      form.value.observaciones = existente.observaciones ?? ''
      form.value.justificacion = existente.justificacion ?? ''
      form.value.fecha_evaluacion = existente.fecha_evaluacion ?? hoy
    }
  } finally {
    loading.value = false
  }
}

async function cargarNombres() {
  const indicador = await indicadoresStore.cargarPorId(idIndicador)
  if (!indicador) return
  nombreIndicador.value = indicador.enunciado ?? indicador.nombre ?? ''

  await componentesStore.cargarPorId(indicador.id_componente)
  nombreComponente.value = componentesStore.componenteActual?.nombre ?? ''
}

async function guardarEvaluacion() {
  const d = form.value.calificacion_documental
  const c = form.value.calificacion_cuantitativa
  const o = form.value.calificacion_opinion

  if (d == null && c == null && o == null) {
    mostrarError('Ingrese al menos una calificación.')
    return
  }

  const fueraRango = [
    { campo: 'Documental', val: d },
    { campo: 'Cuantitativa', val: c },
    { campo: 'Opinión', val: o }
  ].filter(x => x.val != null && (x.val < 0 || x.val > 5))
  if (fueraRango.length) {
    mostrarError(`Calificación fuera del rango 0–5: ${fueraRango.map(x => x.campo).join(', ')}`)
    return
  }

  if (!form.value.fecha_evaluacion) {
    mostrarError('La fecha de evaluación es obligatoria.')
    return
  }

  guardando.value = true
  try {
    if (esEdicion.value && evaluacionId.value) {
      const result = await store.actualizar(evaluacionId.value, {
        calificacion_documental: d,
        calificacion_cuantitativa: c,
        calificacion_opinion: o,
        observaciones: form.value.observaciones || undefined,
        justificacion: form.value.justificacion || undefined
      })
      if (result.ok) {
        mostrarExito('Evaluación actualizada correctamente.')
      } else {
        const msgs = result.errors
          ? Object.values(result.errors).flat().join(' · ')
          : 'Error al actualizar. Revise los campos.'
        mostrarError(msgs)
      }
    } else {
      const result = await store.crearOActualizar({
        id_version: idVersion,
        id_indicador: idIndicador,
        id_usuario: idUsuario.value ?? 1,
        calificacion_documental: d,
        calificacion_cuantitativa: c,
        calificacion_opinion: o,
        observaciones: form.value.observaciones || null,
        justificacion: form.value.justificacion || null,
        fecha_evaluacion: form.value.fecha_evaluacion
      })
      if (result.ok) {
        const verb = result.status === 201 ? 'registrada' : 'actualizada'
        mostrarExito(`Evaluación ${verb} exitosamente.`)
        if (result.data?.id) evaluacionId.value = result.data.id
      } else {
        const msgs = result.errors
          ? Object.values(result.errors).flat().join(' · ')
          : 'Error al guardar. Revise los campos.'
        mostrarError(msgs)
      }
    }
  } finally {
    guardando.value = false
  }
}

// ── Instrumento de Opinión ────────────────────────────────────────────
const hayInstrumentoOpinion = ref(false)
const respuestasOpinion = ref<RespuestasFormulario[]>([])
const personaFiltradaOpinion = ref<string | null>(null)

const todosRespondientesOpinion = computed(() => {
  const vistos = new Set<string>()
  const lista: { google_response_id: string; label: string }[] = []
  for (const rf of respuestasOpinion.value) {
    for (const p of rf.respondientes ?? []) {
      if (!vistos.has(p.google_response_id)) {
        vistos.add(p.google_response_id)
        lista.push({
          google_response_id: p.google_response_id,
          label: p.nombre || p.email || 'Anónimo'
        })
      }
    }
  }
  return lista
})

function respuestasDePersonaOpinion(rf: RespuestasFormulario, responseId: string): RespuestaIndividual[] {
  return rf.respuestas.filter(r => r.google_response_id === responseId)
}

async function cargarInstrumentoOpinion() {
  await indicadorInstrumentoStore.getRelaciones()
  const relaciones = indicadorInstrumentoStore.relaciones.filter(r => r.id_indicador === idIndicador)
  for (const rel of relaciones) {
    await configOpinionStore.listar({ id_instrumento: rel.id_instrumento })
    if (configOpinionStore.configuraciones.length > 0) {
      hayInstrumentoOpinion.value = true
      const ultima = configOpinionStore.configuraciones[configOpinionStore.configuraciones.length - 1]
      await configOpinionStore.cargarRespuestas(ultima.id_configuracion)
      respuestasOpinion.value = [...configOpinionStore.respuestas]
      break
    }
  }
}

onMounted(() => {
  if (Number.isFinite(idVersion) && Number.isFinite(idIndicador)) {
    cargarConfiguracion()
    cargarEvaluacionExistente()
    cargarNombres()
    cargarInstrumentoOpinion()
  }
})
</script>

<style scoped>
.formulario-modelo {
  background-color: white;
  padding: 2rem;
  border-radius: var(--radius-lg);
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  box-shadow: var(--shadow-md);
  box-sizing: border-box;
  margin: 20px;
  font-family: var(--font-family);
}

.header-flex {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 0.75rem;
}
h1 { font-size: 1.4rem; font-weight: 700; margin: 0; color: #111; }
.header-sub { margin: 4px 0 0; font-size: 0.9rem; color: #6b7280; font-weight: 500; }

.divider { border: none; border-bottom: 1px solid #e0e0e0; margin-bottom: 1.5rem; }

/* ── Calificaciones ───────────────────────────── */
.calificaciones-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.cal-card {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.cal-card--error { border-color: #dc3545; background-color: #fff5f5; }
.cal-card > label { font-weight: 600; font-size: 0.85rem; color: #374151; }

.cal-input {
  font-size: 1.5rem;
  font-weight: 700;
  text-align: center;
  padding: 0.5rem;
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #e6e5e5;
  border-radius: 8px;
  background: #f9f9f9;
  font-family: var(--font-family);
  transition: border-color 0.15s, box-shadow 0.15s;
}
.cal-input:focus {
  outline: none;
  border-color: #0e69a0;
  box-shadow: 0 0 0 3px rgba(14, 105, 160, 0.1);
}
.cal-input.input--error {
  border-color: #dc3545 !important;
  box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.15);
  color: #dc3545;
}

.cal-error-msg {
  margin: 0;
  font-size: 0.78rem;
  font-weight: 600;
  color: #dc3545;
}
.cal-error-msg::before { content: '⚠ '; }

.range-bar { height: 6px; background: #eee; border-radius: 3px; overflow: hidden; }
.range-fill { height: 100%; background: #0e69a0; border-radius: 3px; transition: width 0.2s ease; }

.cal-input--bloqueado {
  background: #f3f4f6;
  color: #6b7280;
  border-color: #e5e7eb;
  cursor: default;
}

.btn-cal-modificar {
  margin-top: 0.5rem;
  width: 100%;
  font-size: 0.82rem;
  padding: 0.35rem 0.75rem;
  height: auto;
  justify-content: center;
}

/* ── Resultado final ──────────────────────────── */
.resultado-final {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.25rem;
  background: #f8f9fa;
  border-radius: 8px;
  margin-bottom: 1.5rem;
  border: 1px solid #e0e0e0;
}
.resultado-label { font-weight: 600; font-size: 1rem; color: #111; }
.resultado-valor { font-size: 1.8rem; font-weight: 700; }
.nivel-excelente { color: #28a745; }
.nivel-alto { color: #17a2b8; }
.nivel-medio { color: #ffc107; }
.nivel-bajo { color: #dc3545; }

/* ── Campos del formulario ────────────────────── */
.fila { display: flex; flex-direction: column; gap: 0.4rem; margin-bottom: 1rem; }
.fila > label { font-weight: 600; font-size: 0.9rem; color: #374151; }

.campo-readonly {
  padding: 0.6rem 0.75rem;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 0.95rem;
  font-family: inherit;
  background: #f3f4f6;
  color: #6b7280;
  width: 100%;
  box-sizing: border-box;
}

.campo-fecha {
  padding: 0.6rem 0.75rem;
  border: 1px solid #e6e5e5;
  border-radius: 8px;
  font-size: 0.95rem;
  font-family: inherit;
  background: #f9f9f9;
  width: 100%;
  box-sizing: border-box;
  transition: border-color 0.15s, box-shadow 0.15s;
}
.campo-fecha:focus {
  outline: none;
  border-color: #0e69a0;
  box-shadow: 0 0 0 3px rgba(14, 105, 160, 0.1);
}

.campo-texto {
  padding: 0.6rem 0.75rem;
  border: 1px solid #e6e5e5;
  border-radius: 8px;
  font-size: 0.95rem;
  font-family: inherit;
  background: #f9f9f9;
  width: 100%;
  box-sizing: border-box;
  resize: vertical;
  min-height: 72px;
  transition: border-color 0.15s, box-shadow 0.15s;
}
.campo-texto:focus {
  outline: none;
  border-color: #0e69a0;
  box-shadow: 0 0 0 3px rgba(14, 105, 160, 0.1);
}

/* ── Instrumento de Opinión ───────────────────── */
.opinion-panel {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 1rem 1.25rem;
  margin-bottom: 1.5rem;
  background: #fafafa;
}

.opinion-titulo {
  font-size: 0.95rem;
  font-weight: 700;
  color: #374151;
  margin: 0 0 1rem;
}

.opinion-vacio {
  color: #9ca3af;
  font-size: 0.88rem;
  font-style: italic;
  padding: 0.5rem 0;
}

.persona-filtro {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  margin-bottom: 1rem;
  flex-wrap: wrap;
}

.persona-filtro-label {
  font-size: 0.85rem;
  font-weight: 600;
  color: #374151;
  white-space: nowrap;
}

.persona-filtro-select {
  border: 1px solid #d1d5db;
  border-radius: 6px;
  padding: 0.35rem 0.6rem;
  font-size: 0.85rem;
  font-family: var(--font-family);
  background: white;
  cursor: pointer;
  min-width: 200px;
}

.resp-grupo-op {
  margin-bottom: 1rem;
}

.resp-grupo-titulo {
  font-size: 0.88rem;
  font-weight: 600;
  color: #4b5563;
  margin: 0 0 0.6rem;
  display: flex;
  align-items: center;
  gap: 0.4rem;
}

.op-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #0e69a0;
  color: white;
  border-radius: 999px;
  font-size: 0.7rem;
  font-weight: 700;
  padding: 1px 7px;
  line-height: 1.6;
}

.persona-card-op {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 0.75rem 1rem;
  margin-bottom: 0.5rem;
  background: white;
}

.persona-head-op {
  display: flex;
  align-items: baseline;
  gap: 0.5rem;
  flex-wrap: wrap;
  margin-bottom: 0.5rem;
}

.persona-nombre-op { font-size: 0.9rem; color: #111; }
.persona-email-op  { font-size: 0.78rem; color: #6b7280; }
.persona-fecha-op  { font-size: 0.75rem; color: #9ca3af; margin-left: auto; }

.persona-resp-op {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.pr-item-op {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 0.75rem;
  font-size: 0.85rem;
  padding: 0.3rem 0;
  border-top: 1px solid #f3f4f6;
}

.pr-enunciado-op { color: #4b5563; flex: 1; }
.pr-valor-op     { font-weight: 600; color: #111; white-space: nowrap; }

/* ── Botones ──────────────────────────────────── */
.botones { display: flex; gap: 0.75rem; justify-content: flex-end; margin-top: 1.5rem; }

.btn {
  padding: 0.6rem 1.25rem;
  font-weight: 600;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.15s ease;
  font-family: var(--font-family);
  font-size: 0.9rem;
  height: 40px;
  display: inline-flex;
  align-items: center;
}
.btn.salir { background-color: white; border: 1px solid #ccc; color: #333; }
.btn.salir:hover { background-color: #d41a1a; color: white; }
.btn.guardar { background-color: #eea222; color: black; }
.btn.guardar:hover:not(:disabled) { background-color: #0e69a0; color: white; }
.btn.guardar:disabled { opacity: 0.5; cursor: not-allowed; }
/* Marca de campo no obligatorio */
.opcional { font-weight: 400; font-size: 0.78rem; color: #9aa5b1; }
</style>
